<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  height: {
    type: [String, Number],
    default: 600,
  },
  marginBottom: {
    type: [String, Number],
    default: 32,
  },
});

const wrapperHeight = computed(() => {
  return typeof props.height === "number" ? `${props.height}px` : props.height;
});

const marginBottom = computed(() => {
  return typeof props.marginBottom === "number" ? `${props.marginBottom}px` : props.marginBottom;
});
</script>
<template>
  <!-- style kept: height and marginBottom are dynamic prop values that cannot be expressed as static Tailwind classes -->
  <div
    class="text-type-default flex w-full shrink-0 flex-col"
    :style="{ height: wrapperHeight, marginBottom: marginBottom }">
    <div
      v-if="props.title"
      class="t-sh5 p-px-16 pt-0">
      {{ props.title }}
    </div>
    <div class="p-px-16 rounded-4 h-full w-full border border-slate-200 bg-slate-50 shadow-xs">
      <slot />
    </div>
  </div>
</template>
